import axios from "axios";
import dayjs from "dayjs";
export const getWidgetPositionStyle = (position, btn) => {
    switch (position) {
      case "Top-Left":
        return { top: "0", left: "0", transform: "translate(0, 0)" };
      case "Top-Middle":
        return { top: "0", left: "50%", transform: "translateX(-50%)" };
      case "Top-Right":
        return { top: "0", right: "0", transform: "translate(0, 0)" };
      case "Middle-Left":
        return { top: "50%", left: "0", transform: "translateY(-50%)" };
      case "Middle-Center":
        return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
      case "Middle-Right":
        return { top: "50%", right: "0", transform: "translateY(-50%)" };
      case "Bottom-Left":
        return { bottom: "0", left: "0", transform: "translate(0, 0)" };
      case "Bottom-Middle":
        return { bottom: "0", left: "50%", transform: "translateX(-50%)" };
      case "Bottom-Right":
        return { bottom: "0", right: "0", transform: "translate(0, 0)" };
      default:
        // Center by default if position not recognized
        if (btn) {
          return { bottom: "0", right: "0", transform: "translate(0, 0)" };
        } else {
          return {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          };
        }
    }
  };
export const IMG_BASE_URL=process.env.REACT_APP_API_LOCAL_IMG_URL;
export const format_Number = (num) => {
  let formattedPrice = (parseFloat(num)).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return formattedPrice.replace('.', ',');
}

// export const fetchData = async ({ endpoint, method = "GET", params = {}, data = {} }) => {
//     try {
//         // Validate required parameter
//         if (!endpoint) {
//             throw new Error("Missing required parameter: endpoint");
//         }

//         // Configure the request
//         const config = {
//             method,
//             url: endpoint,
//             ...(method === "GET" && { params }), // Add query params for GET
//             ...(method !== "GET" && { data }),   // Add body data for POST/PUT
//         };

//         // Make the API call
//         const response = await axios(config);

//         // Validate the response
//         if (response?.status === 200 && response?.data) {
//             return response.data;
//         } else {
//             throw new Error(`Unexpected response format or status code: ${response?.status}`);
//         }
//     } catch (error) {
//         // Log and return a friendly error message
//         console.error("Error in API request:", error.message || error);
//         return {
//             success: false,
//             message: error.message || "Error during the API request. Please try again.",
//         };
//     }
// };
export const fetchData = async ({ endpoint, method = "GET", params = {}, data = {} }) => {
  try {
      if (!endpoint) {
          throw new Error("Missing required parameter: endpoint");
      }

      // Configure axios request
      const config = {
          method,
          url: endpoint,
          params: method === "GET" ? params || {} : undefined, // Attach params only for GET
          data: method !== "GET" ? data || {} : undefined,     // Attach data only for POST/PUT
      };

      const response = await axios(config);

      // Ensure response has valid data
      if (response?.status === 200 && response?.data) {
          return response.data;
      } else {
          throw new Error(`Unexpected response format or status code: ${response?.status}`);
      }
  } catch (error) {
      console.error("Error in API request:", error.response?.data || error.message || error);

      return {
          success: false,
          message: error.response?.data?.message || error.message || "Error during the API request. Please try again.",
      };
  }
};

export   const validateSupplements = (selectedProduct,supplementsInfo,webShopProductInfo,setErrors,dispatch,recommededProducts) => {
 
  let errors = {};
  // Ensure supplementsInfo is an array
  let supplementsData = Array.isArray(supplementsInfo)
    ? supplementsInfo.find((s) => s.idproduct == selectedProduct?.idproduct)
        ?.supplements || []
    : [];
    console.log('recommended', recommededProducts,webShopProductInfo?.data?.maxOneSelectedQtyForRelatedProduct,supplementsData)
  if (
    recommededProducts &&
    webShopProductInfo?.data?.maxOneSelectedQtyForRelatedProduct &&
    supplementsData?.length >= 1
  ) {
    errors.message =
      "You can only select one supplement for each related product";
    dispatch(setErrors(errors));
    return errors;
  }
  // **Dynamic error message for empty supplementsData**
  if (supplementsData.length === 0) {
    let errorMessage = "Please select the Supplements  ";
    let conditions = [];
    errorMessage += conditions.join(", ") + ".";
    errors.message = errorMessage;
    dispatch(setErrors(errors));
    return errors;
  }

  // Extract supplements based on detailsKey
  const supp1 = supplementsData.filter(
    (s) => s?.detailsKey === "supplementProductsDetails1"
  );
  const supp2 = supplementsData.filter(
    (s) => s?.detailsKey === "supplementProductsDetails2"
  );
  const supp3 = supplementsData.filter(
    (s) => s?.detailsKey === "supplementProductsDetails3"
  );
  console.log("supplements", supp2);

  // **Category-wise validation**
  if (
    webShopProductInfo?.data?.supplementProductRequired_1 &&
    supp1.length === 0
  ) {
    errors.message = "At least one supplement is required for Supplement 1";
    dispatch(setErrors(errors));
    return errors;
  }
  if (
    webShopProductInfo?.data?.supplementProductOnlyOneSelected_1 &&
    supp1.length > 1 &&
    webShopProductInfo?.data?.supplementProductRequired_1
  ) {
    errors.message = "Only one supplement can be selected for Supplement 1";
    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductRequired_2 &&
    supp2.length === 0
  ) {
    errors.message = "At least one supplement is required for Supplement 2";
    dispatch(setErrors(errors));
    return errors;
  }
  if (
    webShopProductInfo?.data?.supplementProductOnlyOneSelected_2 &&
    supp2.length > 1 &&
    webShopProductInfo?.data?.supplementProductRequired_2
  ) {
    errors.message = "Only one supplement can be selected for Supplement 2";
    dispatch(setErrors(errors));
    return errors;
  }

  if (
    webShopProductInfo?.data?.supplementProductRequired_3 &&
    supp3.length === 0
  ) {
    errors.message = "At least one supplement is required for Supplement 3";
    dispatch(setErrors(errors));
    return errors;
  }
  if (
    webShopProductInfo?.data?.supplementProductOnlyOneSelected_3 &&
    supp3.length > 1 &&
    webShopProductInfo?.data?.supplementProductRequired_3
  ) {
    errors.message = "Only one supplement can be selected for Supplement 3";
    dispatch(setErrors(errors));
    return errors;
  }
  console.log("errorss",errors)
  dispatch(setErrors(errors));
  return errors;
};

export const convertToTimeFormat = (name) => {
  const regex = /price(\d+)Hour(?:s)?(?:(\d+)Minutes)?/;
  const match = name?.match(regex);

  if (match) {
    let hours = parseInt(match[1], 10) || 0;
    let minutes = match[2] ? parseInt(match[2], 10) : 0;

    // Format HH:MM:SS
    const formattedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:00`;

    return formattedTime;
  }

  return "00:00:00"; // Default if no match
};


export const calculateEndTime = (startTime, duration) => {
  // Convert startTime string to dayjs object
  const start = dayjs(`2024-01-01T${startTime}`);

  // Extract hours and minutes from the duration string (1:30:00)
  const [hours, minutes] = duration.split(":").map(Number);

  // Add extracted time to startTime
  const end = start.add(hours, "hour").add(minutes, "minute");

  // Return formatted time
  return end.format("HH:mm:ss");
};

export function timeToSeconds(time) {
  const [hours, minutes, seconds] = time.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
}

export function convertToMinutes(time) {
  if (!time) return 0;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
}

export const formatName = (name,languageWords) => {
  const regex = /price(\d+)Hour(?:s)?(?:(\d+)Minutes)?/;
  const match = name.match(regex);

  if (match) {
    let hours = parseInt(match[1], 10);
    let minutes = match[2] ? parseInt(match[2], 10) : 0;

    let formattedName = `${hours} ${languageWords?.hrs}`;
    if (minutes > 0) {
      formattedName += ` ${minutes} ${languageWords?.mins}`;
    }

    return formattedName;
  }

  return name;
};
export function translateTimeValue(timeValue,languageWords) {
  // Split the input string into an array
  const [year, month, day, hour, min] = timeValue.split('/').map(Number);

  // Calculate total minutes
  const totalMinutes = (year * 525600) + (month * 43800) + (day * 1440) + (hour * 60) + min;

  // Convert to human-readable format
  let result = [];

  if (year > 0) result.push(`${year} ${languageWords?.year || 'year'}${year > 1 ? 's' : ''}`);
  if (month > 0) result.push(`${month} ${languageWords?.month || 'month'}${month > 1 ? 's' : ''}`);
  if (day > 0) result.push(`${day} ${languageWords?.day || 'day'}${day > 1 ? 's' : ''}`);
  if (hour > 0) result.push(`${hour} ${languageWords?.hrs}${hour > 1 ? 's' : ''}`);
  if (min > 0) result.push(`${min} ${languageWords?.mins}${min > 1 ? 's' : ''}`);

  // If only minutes exist and they exceed 60, convert them
  if (result.length === 1 && min > 60) {
      let hrs = Math.floor(min / 60);
      let minsLeft = min % 60;
      return `${hrs} ${languageWords?.hrs}${hrs > 1 ? 's' : ''} ${minsLeft} ${languageWords?.mins}${minsLeft > 1 ? 's' : ''}`;
  }

  return result.join(' ');
}
export function convertToSeconds(timeValue) {
  const [year, month, day, hour, min] = timeValue.split('/').map(Number);

  const totalSeconds =
    (year * 365 * 24 * 60 * 60) +      // Years to seconds
    (month * 30 * 24 * 60 * 60) +      // Months to seconds (approximate)
    (day * 24 * 60 * 60) +             // Days to seconds
    (hour * 60 * 60) +                 // Hours to seconds
    (min * 60);                        // Minutes to seconds

  return totalSeconds;
}


export const send = (
  frameHeight,
  frameWidth,
  top,
  right,
  bottom,
  left,
  floating,
  redirectUrl
) => {
  window.parent.postMessage(
    {
      reservationIframeHeight: frameHeight,
      reservationIframeWidth: frameWidth,
      reservationIframePositionTop: top,
      reservationIframePositionRight: right,
      reservationIframePositionBottom: bottom,
      reservationIframePositionLeft: left,
      reservationIframePositionFloating: floating,
      redirectUrl: redirectUrl,
    },
    "*"
  );
};

export function calculateEndTimes(startTime, durationInSeconds) {
  // Split startTime into hours and minutes
  let [startHours, startMinutes] = startTime?.split(":")?.map(Number);

  // Convert start time to total minutes
  let totalMinutes = startHours * 60 + startMinutes + Math.floor(durationInSeconds / 60);
  let remainingSeconds = durationInSeconds % 60;

  // Calculate new hours and minutes
  let endHours = Math.floor(totalMinutes / 60) % 24; // Modulo 24 for 24-hour format
  let endMinutes = totalMinutes % 60;

  // Format hours and minutes to always be two digits
  let formattedEndTime = `${String(endHours).padStart(2, "0")}:${String(endMinutes).padStart(2, "0")}`;

  return {
    endTime: formattedEndTime,
    formattedDuration: formatDuration(durationInSeconds),
  };
}

// Helper function to format duration
function formatDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  return `${hours}h ${minutes}m ${remainingSeconds}s`;
}

export function formatTimeString(text,language) {
  // const language = {
  //   month: "Month",
  //   months: "Months",
  //   day: "Day",
  //   days: "Days",
  //   hour: "Hour",
  //   hours: "Hours",
  //   minute: "Minute",
  //   minutes: "Minutes"
  // };

  const words = text.split(" "); // Split the text into an array
  const formattedParts = [];

  for (let i = 0; i < words.length; i += 2) {
    const num = words[i]; // Extract number
    const unit = words[i + 1]; // Extract unit
    formattedParts.push(`${num} ${language[unit] || unit}`); // Map the unit dynamically
  }

  return formattedParts.join(" "); // Join the formatted parts into a string
}






